module.exports = __webpack_public_path__ + "img/tpc-36.1eea03bf.webp";